import { Serializer } from "../resource/serializer.interface";
import { PreferenceFrequency } from "./preference-frequency.model";

export class PreferenceFrequencySerializer implements Serializer {
    fromJson(json: any): PreferenceFrequency {
        const preferenceFrequency = new PreferenceFrequency();
        preferenceFrequency.id = json.id;
        preferenceFrequency.name = json.name;
        preferenceFrequency.code = json.code;
        preferenceFrequency.description = json.description;
        preferenceFrequency.status = json.status;
        preferenceFrequency.tenantId = json.tenant_id;
        return preferenceFrequency;
    }

    toJson(preferenceFrequency: PreferenceFrequency): any {
        return {
            id: preferenceFrequency.id,
            name: preferenceFrequency.name,
            code: preferenceFrequency.code,
            description: preferenceFrequency.description,
            status: preferenceFrequency.status,
            tenant_id: preferenceFrequency.tenantId
        };
    }
}